export const trb_banner = require('./TRB_Banner.png');
